<template>
  <div class="bg-white dark:bg-gray-900 rounded-lg shadow-sm border border-gray-100 dark:border-gray-800 p-6">
    <h1 class="text-3xl font-bold text-gray-900 dark:text-white mb-6">Contact Us</h1>
    
    <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
      <!-- Contact Form -->
      <div>
        <h2 class="text-xl font-semibold text-gray-800 dark:text-white mb-4">Send us a message</h2>
        <form class="space-y-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Name</label>
            <input
              type="text"
              class="w-full px-4 py-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800"
            />
          </div>
          
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Email</label>
            <input
              type="email"
              class="w-full px-4 py-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800"
            />
          </div>
          
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Subject</label>
            <input
              type="text"
              class="w-full px-4 py-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800"
            />
          </div>
          
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Message</label>
            <textarea
              rows="4"
              class="w-full px-4 py-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800"
            ></textarea>
          </div>
          
          <button
            type="submit"
            class="w-full px-4 py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-700"
          >
            Send Message
          </button>
        </form>
      </div>

      <!-- Contact Information -->
      <div>
        <h2 class="text-xl font-semibold text-gray-800 dark:text-white mb-4">Get in touch</h2>
        
        <div class="space-y-6">
          <div class="flex items-start gap-4">
            <div class="w-10 h-10 rounded-lg bg-blue-100 dark:bg-blue-900 flex items-center justify-center text-blue-600">
              📍
            </div>
            <div>
              <h3 class="font-medium text-gray-900 dark:text-white">Address</h3>
              <p class="text-gray-600 dark:text-gray-400">
                First Floor<br>
                Ranna<br>
                Maafannu, Male
              </p>
            </div>
          </div>

          <div class="flex items-start gap-4">
            <div class="w-10 h-10 rounded-lg bg-blue-100 dark:bg-blue-900 flex items-center justify-center text-blue-600">
              📞
            </div>
            <div>
              <h3 class="font-medium text-gray-900 dark:text-white">Phone</h3>
              <p class="text-gray-600 dark:text-gray-400">
                Sales: +960 777 7878<br>
                Support: +960 777 7878
              </p>
            </div>
          </div>

          <div class="flex items-start gap-4">
            <div class="w-10 h-10 rounded-lg bg-blue-100 dark:bg-blue-900 flex items-center justify-center text-blue-600">
              📧
            </div>
            <div>
              <h3 class="font-medium text-gray-900 dark:text-white">Email</h3>
              <p class="text-gray-600 dark:text-gray-400">
                Sales: <a href="mailto:sales@faseyhapos.mv">sales@faseyhapos.mv</a><br>
                Support: <a href="mailto:support@faseyhapos.mv">support@faseyhapos.mv</a>
              </p>
            </div>
          </div>

          <div class="flex items-start gap-4">
            <div class="w-10 h-10 rounded-lg bg-blue-100 dark:bg-blue-900 flex items-center justify-center text-blue-600">
              ⏰
            </div>
            <div>
              <h3 class="font-medium text-gray-900 dark:text-white">Business Hours</h3>
              <p class="text-gray-600 dark:text-gray-400">
                Saturday - Thursday: 9:00 AM - 6:00 PM<br>
                Friday: Closed
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Google Maps -->
    <div class="mt-8">
      <h2 class="text-xl font-semibold text-gray-800 dark:text-white mb-4">Find Us</h2>
      <div class="map-container" id="map-container">
        <div ref="mapContainer" class="map"></div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Loader } from '@googlemaps/js-api-loader';
import { onMounted, ref } from 'vue'

const GOOGLE_MAPS_API_KEY = 'AIzaSyBC8jOzS5ifnpBsK4QT6rfVNdxmO483m8w';
const loader = new Loader({
  apiKey: GOOGLE_MAPS_API_KEY,
  version: 'weekly',
  libraries: ['places']
});
const map = ref<google.maps.Map | null>(null);
const mapContainer = ref<HTMLElement | null>(null);

const initMap = async () => {
  try {
    const google = await loader.load();
    const defaultLocation = { lat: 4.175835330966198, lng: 73.5035380964798 };

    map.value = new google.maps.Map(mapContainer.value!, {
      center: defaultLocation,
      zoom: 20, // Max zoom level
      mapTypeId: 'roadmap',
      disableDefaultUI: false,
      mapTypeControl: false
    });

    // Add a marker at the default location
    new google.maps.Marker({
      position: defaultLocation,
      map: map.value,
      title: 'Default Location'
    });

  
  } catch (error) {
    console.error('Error loading Google Maps:', error);
  }
};

onMounted(() => {
  initMap()
})
</script>
<style scoped>
.map-container {
  width: 100%;
  height: 100vh;
  position: relative;
}

.map {
  width: 100%;
  height: 100%;
}
</style>